import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { z } from 'zod';
import { en as zodEn } from 'zod/v4/locales';
import { ja as zodJa } from 'zod/v4/locales';

// Translation files
import jaTranslations from '../locales/ja';
import enTranslations from '../locales/en';

const resources = {
  ja: {
    translation: jaTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'ja', // Default language is Japanese as per requirements
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // navigator を order から除外することで、ブラウザの言語設定を無視
      // localStorage や cookie に設定がない場合は fallbackLng（日本語）を使用
      order: ['localStorage', 'cookie', 'querystring'],
      caches: ['localStorage', 'cookie'],
    },
  });

/**
 * Zod's built-in messages ("Invalid input: expected string, received undefined")
 * are raw English and bypass our locale bundles entirely — a schema only ever
 * supplies copy for the rules it states, so a type mismatch or a missing field
 * leaks English into a Japanese-first UI. Zod ships its own ja/en catalogs, so
 * bind them to the interface language instead of re-authoring them as keys.
 * Schema-level messages still win over these.
 */
const applyZodLocale = (language: string): void => {
  z.config(language.slice(0, 2) === 'en' ? zodEn() : zodJa());
};

applyZodLocale(i18n.language || 'ja');
i18n.on('languageChanged', applyZodLocale);

export default i18n;
